// extracted by mini-css-extract-plugin
export default {"row":"row_row__+HQWN","col":"row_col__n-2lR","item":"row_item__e7z8d","pills":"row_pills__Y9WPS","green":"row_green__pF0fj","red":"row_red__USFX4","blue":"row_blue__i0D56"};